var _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisplay1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.861 22.698v-19.192h-27.723v19.192h13.328v2.062l-5.056 2.8 0.516 0.933 5.073-2.81 5.073 2.81 0.516-0.933-5.056-2.8v-2.062h13.328zM3.205 4.572h25.59v17.060h-25.59v-17.060z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.294 15.427l-3.162-4.41-2.116 4.103-3.327-6.713-2.429 8.965 1.029 0.279 1.694-6.25 3.014 6.082 2.284-4.428 3.414 4.761 2.948-9.892-1.021-0.305z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.464 9.903c-1.764 0-3.199 1.435-3.199 3.199s1.435 3.199 3.199 3.199c1.763 0 3.198-1.435 3.198-3.199s-1.435-3.199-3.198-3.199zM23.464 15.235c-1.176 0-2.133-0.956-2.133-2.133s0.957-2.133 2.133-2.133c1.176 0 2.132 0.956 2.132 2.133s-0.956 2.133-2.132 2.133z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplay1);
export default __webpack_public_path__ + "static/media/display1.03435e18e89df29accc04b648814adef.svg";
export { ForwardRef as ReactComponent };